module.exports = __webpack_public_path__ + "static/media/renfrewBg.8e076543.png";